import Toast, { ToastStyles } from 'components/common/toasts/Toast';
import { translate } from 'support/translate';

export type MyStuffToastType = 'Added' | 'Removed';

const ADDED_TOAST_STYLES: ToastStyles = {
  bgColor: 'toastAddedBackground',
  strokeColor: 'toastAddedBorder',
  iconPath: 'static/images/checkmark-circle-white.svg',
};

const REMOVED_TOAST_STYLES: ToastStyles = {
  bgColor: 'serviceErrorBackground',
  strokeColor: 'serviceErrorBorder',
  iconPath: 'static/images/circle-alert.svg',
};

export default class MyStuffToast extends Toast {
  private isMyStuffAdded: boolean | undefined = undefined;

  updateMessage(isAdded: boolean, message: string) {
    const status = translate(isAdded ? 'myStuff.added' : 'myStuff.removed');
    const newMessage = `<b>${status}: </b>${message}`;

    if (this.isMyStuffAdded !== isAdded) {
      this.toastStyles = isAdded ? ADDED_TOAST_STYLES : REMOVED_TOAST_STYLES;

      this.isMyStuffAdded = isAdded;
    }

    this.message = newMessage;
  }
}
